import { cohortConfigType } from '@/types';

import { AccessCMD } from './welcome/accesscmd';
import { AccessILD } from './welcome/accessild';
import { AccessPD } from './welcome/accesspd';

const cohortConfig: { [key: string]: cohortConfigType } = {
	accesspd: {
		name: 'AccessPD',
		WelcomeContent: AccessPD,
		code: 'APD',
		siteURL: 'https://www.accesspd.org/',
	},
	accessild: {
		name: 'AccessILD',
		WelcomeContent: AccessILD,
		code: 'AILDP',
		siteURL: 'https://www.accessild.org/',
	},
	accesscmd: {
		name: 'AccessCMD',
		WelcomeContent: AccessCMD,
		code: 'ACMD',
		siteURL: 'https://www.accesscmd.org/',
	},
};
const currentHostname = window.location.hostname;

const cohortKey = (() => {
	if (currentHostname.includes('accesspd')) return 'accesspd';
	if (currentHostname.includes('accessild')) return 'accessild';
	if (currentHostname.includes('accesscmd')) return 'accesscmd';
	if (currentHostname === 'localhost') return 'accesspd';
	return '';
})();
export const currentCohort = cohortConfig[cohortKey];
